import React, { useEffect, useRef } from "react";
import SwInspectionReports from "../components/SwInspectionReports";
import { useDispatch, useSelector } from "react-redux";
import * as clientAction from "../../../../redux/actions/clientAction";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import {
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  PAGE_SIZE,
} from "../../../../constant/constant";
import { getDateWithDayPast } from "../../../../utils/helper";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";
import { useLocation } from "react-router-dom";
import Loader from "../../../../library/common/Loader";

function SwInspectionReportsContainer() {
  const location = useLocation();
  const dashboardReportPath = location.state?.dashboardReportPath;

  const preservedState = useRef(
    (() => {
      if (sessionStorage.getItem("swInspReportsPreserve") !== "true")
        return null;
      try {
        const filter = JSON.parse(
          sessionStorage.getItem("swInspReportsFilter") || "null",
        );
        const ui = JSON.parse(
          sessionStorage.getItem("swInspReportsUI") || "null",
        );
        sessionStorage.removeItem("swInspReportsPreserve");
        sessionStorage.removeItem("swInspReportsFilter");
        sessionStorage.removeItem("swInspReportsUI");
        return filter && ui ? { filter, ui } : null;
      } catch {
        return null;
      }
    })(),
  );

  const orgId = localStorage.getItem("orgId");
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.allUsers);
  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };
  const allClients = useSelector((state) => state.searchAllClientsReducerData);
  const isSearchClientLoading = allClients.isLoading;

  const getSwInspectionList = useSelector((state) => state.getSwInspectionList);

  const getSwInspectionListData = (data) => {
    dispatch(swInspectionAction.getSwInspectionList(data));
  };

  const getSwReference = useSelector((state) => state.getSwReference);
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };

  const refData = {
    flags: [3, 4],
  };

  useEffect(() => {
    getSwReferenceData(refData);
  }, []);

  const sevenDayRange = getDateWithDayPast(7);
  const defaultData = {
    search: "",
    inspectionTypeId: 0,
    frequencyId: "",
    projectId: 0,
    customerId: LOGIN_ORG_ID() === parseInt(HBNEXT_ORG_ID) ? 1 : orgId,
    statusId: 6,
    startDate: dashboardReportPath ? sevenDayRange.pastData : "",
    endDate: dashboardReportPath ? sevenDayRange.getCurrentDate : "",
    page: 1,
    pageSize: PAGE_SIZE,
    userId: "",
    inspectionSubmitType: "",
    statusIds: 5,
  };

  useEffect(() => {
    const initial = preservedState.current?.filter ?? defaultData;
    getSwInspectionListData(initial);
  }, []);

  const autoSearchDataLoading =
    allUsers?.isLoading || getSwInspectionList?.isLoading;
  return (
    <>
      {autoSearchDataLoading && (
        <>
          <Loader />
        </>
      )}
      <SwInspectionReports
        autoSearchDataLoading={autoSearchDataLoading}
        allClients={allClients}
        searchClient={searchClient}
        allUsers={allUsers?.data?.users}
        getSwInspectionList={getSwInspectionList?.data}
        getSwInspectionListData={getSwInspectionListData}
        isSearchClientLoading={isSearchClientLoading}
        inspectionTypeValue={getSwReference?.data}
        dashboardReportPath={dashboardReportPath}
        preservedState={preservedState.current}
      />
    </>
  );
}

export default SwInspectionReportsContainer;
